export const defaultState = () => ({
  loading: {
    verifyPin: false,
    verifyName: false,
    verifyOrgName: false
  },
  errors: {
    pin: '',
    getOrganisationName: '',
    getUserName: ''
  },
  response: {
    login: '',
    getOrganisationName: '',
    getUserName: ''
  },
  innOrganisation: '',
  okpo: '',
  innUser: '',
  isAdmin: false
})

export default defaultState()



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js